"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = require("prop-types");

var _react = _interopRequireDefault(require("react"));

var _Pagination = require("./Pagination.styles");

var PageButton = function PageButton(_ref) {
  var append = _ref.append,
      label = _ref.label,
      onClick = _ref.onClick,
      disabled = _ref.disabled,
      prepend = _ref.prepend,
      selected = _ref.selected,
      wide = _ref.wide;
  return /*#__PURE__*/_react["default"].createElement(_Pagination.StyledPageButton, {
    disabled: disabled,
    label: label,
    selected: selected,
    onClick: onClick,
    prepend: prepend,
    append: append,
    size: "small",
    outline: true,
    type: "button",
    element: "button",
    wide: wide
  });
};

PageButton.defaultProps = {
  disabled: false,
  selected: false,
  onClick: function onClick() {},
  wide: false,
  prepend: null,
  append: null
};
PageButton.propTypes = {
  label: _propTypes.string.isRequired,
  disabled: _propTypes.bool,
  selected: _propTypes.bool,
  onClick: _propTypes.func,
  wide: _propTypes.bool,
  prepend: _propTypes.node,
  append: _propTypes.node
};
PageButton.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "PageButton",
  "props": {
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "selected": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "onClick": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "wide": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "prepend": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "append": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "label": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    }
  }
};
var _default = PageButton;
exports["default"] = _default;